import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { FooterComponent } from '../footer-v2/footer-v2.component';
import { CP_ICONS } from '../../../pages/v3/shared/icons';
import { goToHomeSection } from '../../../pages/v3/shared/navigation';

/** v3 skin over the v2 footer: same links, same legal copy. */
@Component({
  selector: 'app-footer-v3',
  standalone: true,
  imports: [RouterModule, NgIcon],
  viewProviders: [provideIcons(CP_ICONS)],
  templateUrl: './footer-v3.component.html',
})
export class FooterV3Component extends FooterComponent {
  private readonly router = inject(Router);

  /** Works from any page (v2's version only scrolled when already on the home page). */
  override scrollToSection(sectionId: string): void {
    void goToHomeSection(this.router, sectionId);
  }

  readonly footerLink =
    'rounded-sm text-cp-muted transition-colors hover:text-cp-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cp-accent';
  readonly socialLink =
    'grid h-8 w-8 place-items-center rounded-full text-cp-muted transition-colors hover:bg-cp-fill hover:text-cp-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-cp-accent';
}
